<template>


  <v-app id="inspire">

    <v-overlay :value="bootstrapping" z-index="300" opacity="1" color="white">
      <div class="d-flex flex-column align-center">
        <v-img src="/UNICEN23.jpg" max-width="120" class="mb-4"></v-img>
        <v-progress-circular indeterminate color="#002245" size="48"></v-progress-circular>
        <div class="mt-3" style="color:#002245">Cargando tu sesión...</div>
      </div>
    </v-overlay>

    <v-navigation-drawer v-model="drawer" v-if="logueado" app width="250">
      <v-toolbar color="#002245" dark flat class="app-drawer-header">
        <v-img src="/UNICEN23.jpg" max-width="28" max-height="28" class="app-drawer-header__logo"></v-img>
        <div class="app-drawer-header__text">
          <span class="app-drawer-header__name">Universidad Central</span>
          <span class="app-drawer-header__sub">Sistema Académico Estudiantil</span>
        </div>
      </v-toolbar>

      <v-list nav dense class="app-drawer-menu">

        <template v-if="menuLoading">
          <v-skeleton-loader type="list-item@6"></v-skeleton-loader>
        </template>

        <template v-else-if="menuError">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                No pudimos cargar tu menú.
              </v-list-item-title>
              <v-btn text small color="#EE680B" @click="listme()">
                Reintentar
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-else-if="dtm.length === 0">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                Tu usuario no tiene módulos asignados. Contactá a Plataforma.
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-tooltip
          v-else
          v-for="(item,index) in dtm"
          :key="index"
          right
          open-delay="1000"
          content-class="app-menu-tooltip"
        >
          <template #activator="{ on, attrs }">
            <v-list-item
              :to="{ name: item.nombre }"
              class="app-drawer-menu__item"
              v-bind="attrs"
              v-on="on"
            >
              <v-list-item-icon>
                <v-icon size="20">{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.nome }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>{{ item.nome }}</span>
        </v-tooltip>

      </v-list>
    </v-navigation-drawer>



    <v-app-bar color="#002245" app class="app-header" elevation="3">
      <v-app-bar-nav-icon color="white" @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <div v-if="user != null" class="app-header__user">
        <div class="app-header__user-text d-none d-sm-flex">
          <span class="app-header__user-name">{{ user.nombres }}</span>
          <!-- Sede activa. Solo los roles nacionales (lo decide el backend) la
               pueden cambiar; para el resto es texto, sin ningún control. -->
          <menu-sede-activa
            v-if="puedeCambiarSede"
            :sedes="sedesElegibles"
            :id-sede="Number(user.id_sede)"
            :nombre-sede="user.sede"
            :cargando="cambiandoSede"
            @elegir="cambiarSede"
          />
          <span v-else class="app-header__user-sede">
            <v-icon size="12" color="#EE680B">mdi-map-marker-outline</v-icon>
            {{ user.sede }}
          </span>
        </div>
        <!-- En celular el texto de arriba no se muestra: el cambio de sede
             queda como un botón con ícono. -->
        <div v-if="puedeCambiarSede" class="d-flex d-sm-none">
          <menu-sede-activa
            compacto
            :sedes="sedesElegibles"
            :id-sede="Number(user.id_sede)"
            :nombre-sede="user.sede"
            :cargando="cambiandoSede"
            @elegir="cambiarSede"
          />
        </div>
      </div>

      <v-divider vertical dark class="mx-3 app-header__divider"></v-divider>

      <template v-if="sd != ''">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn icon dark v-bind="attrs" v-on="on" @click="cambiocontraseña()">
              <v-icon size="20">mdi-lock-reset</v-icon>
            </v-btn>
          </template>
          <span>Cambiar contraseña</span>
        </v-tooltip>
      </template>

      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn icon dark v-bind="attrs" v-on="on" @click="salir()">
            <v-icon size="20">mdi-logout-variant</v-icon>
          </v-btn>
        </template>
        <span>Cerrar sesión</span>
      </v-tooltip>
    </v-app-bar>
    <v-main>
      <v-container fluid class="view-container"> <!--fluid fill-height-->
        <!-- Aviso a quien entra por la IP del servidor en vez del dominio. -->
        <v-alert
          v-if="conectadoPorIp && !avisoIpCerrado"
          type="warning"
          dense
          dismissible
          border="left"
          class="mb-4 aviso-ip"
          @input="cerrarAvisoIp"
        >
          <strong>Conexión no segura.</strong> Estás ingresando por una dirección IP
          ({{ hostActual }}) y tus datos no están protegidos. Para una conexión más segura,
          ingresá a
          <a :href="urlDominio" class="aviso-ip__enlace">{{ urlDominio }}</a>
          para garantizar la seguridad de tus datos.
        </v-alert>
        <base-loading v-if="routeLoading" />
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-main>
    <v-footer color="#002245" padless app fixed class="app-footer">
      <div class="app-footer__accent"></div>
      <div class="app-footer__content">
        <div class="app-footer__brand">
          <v-img src="/UNICEN23.jpg" max-width="32" max-height="32" class="app-footer__brand-logo"></v-img>
          <div class="app-footer__brand-text">
            <span class="app-footer__brand-name">Universidad Central</span>
            <span class="app-footer__brand-sub">Sistema Académico Estudiantil</span>
          </div>
        </div>
        <div class="app-footer__copy">© {{ new Date().getFullYear() }} Universidad UNICEN — Todos los derechos reservados.</div>
      </div>
    </v-footer>
    <custom-snackbar></custom-snackbar>
    <modal-controller></modal-controller>
  </v-app>



</template>
<script>
import axios from "axios";
import CustomSnackbar from "./components/UI/CustomSnackbar.vue";
import ModalController from './components/UI/Modals/ModalController.vue';
import BaseSection from './components/UI/BaseSection.vue';
import BaseLoading from './components/UI/BaseLoading.vue';
import MenuSedeActiva from './components/UI/MenuSedeActiva.vue';
import useSesionApi from './api/sesion/useSesionApi.js';
import { mensajeDeError } from './api/errores.js';
// import Prueba from "./components/Prueba.vue";
export default {
  components: {
    CustomSnackbar,
    ModalController,
    BaseSection,
    BaseLoading,
    MenuSedeActiva,
  },
  data: () => ({
    rl: "",
    us: "",
    sd: "",
    dtm: [],
    drawer: null,
    bootstrapping: true,
    menuLoading: false,
    menuError: false,
    puedeCambiarSede: false,
    sedesElegibles: [],
    cambiandoSede: false,
    avisoIpCerrado: false,
  }),
  computed: {
    hostActual() {
      return window.location.hostname;
    },
    // IPv4 (1.2.3.4) o IPv6 literal ([::1] -> hostname trae los corchetes).
    conectadoPorIp() {
      const host = this.hostActual;
      return /^\d{1,3}(\.\d{1,3}){3}$/.test(host) || host.startsWith('[');
    },
    urlDominio() {
      return process.env.VUE_APP_DOMINIO_URL || 'https://siiaa.unicen.edu.bo';
    },
    user() {
      return this.$store.getters.user;
    },
    logueado() {
      return !!this.user;
    },
    routeLoading() {
      return this.$store.getters.routeLoading;
    }
  },
  watch: {
    user(newUser) {
      if (newUser) {
        this.rl = newUser.id_rol;
        this.us = newUser.personal;
        this.sd = newUser.id_sede;
        this.listme();
        this.cargarContextoSede();
      } else {
        this.rl = "";
        this.us = "";
        this.sd = "";
        this.dtm = [];
        this.puedeCambiarSede = false;
        this.sedesElegibles = [];
      }
    }
  },

  methods: {
    async listme() {
      let me = this;
      this.menuLoading = true;
      this.menuError = false;
      await axios
        .get("/busme/" + this.rl + "," + this.us + "," + this.sd)
        .then(function (response) {
          me.dtm = response.data.resultado == null ? [] : response.data.resultado;
        })
        .catch(function (error) {
          console.log(error);
          me.menuError = true;
          me.dtm = [];
        })
        .finally(function () {
          me.menuLoading = false;
        });
    },
    /**
     * Si el usuario puede cambiar la sede de trabajo, y a cuáles. Lo decide el
     * backend por el rol (modules/sesion). Si falla (p. ej. una sesión vieja
     * sin id_usuario en el token), simplemente no se ofrece el cambio.
     */
    async cargarContextoSede() {
      if (!this.user || !this.user.token) return;
      try {
        const { data } = await useSesionApi.obtenerContexto();
        const contexto = (data && data.data) || {};
        this.puedeCambiarSede = contexto.puede_cambiar_sede === true;
        this.sedesElegibles = contexto.sedes || [];
      } catch (error) {
        this.puedeCambiarSede = false;
        this.sedesElegibles = [];
      }
    },

    /**
     * Cambia la sede de trabajo de toda la sesión: el backend firma un token
     * nuevo con esa sede y se recarga la página, para que todas las pantallas
     * vuelvan a leer la sede de la sesión.
     */
    async cambiarSede(sede) {
      if (this.cambiandoSede || sede.id_sede === Number(this.user.id_sede)) return;
      this.cambiandoSede = true;
      try {
        const { data } = await useSesionApi.cambiarSede(sede.id_sede);
        const nueva = data.data;
        const sesion = JSON.parse(sessionStorage.getItem('session') || '{}');
        const actualizada = { ...sesion, id_sede: nueva.id_sede, sede: nueva.sede, token: nueva.token };
        sessionStorage.setItem('session', JSON.stringify(actualizada));
        this.$store.dispatch('setUser', { user: actualizada });
        window.location.reload();
      } catch (error) {
        this.cambiandoSede = false;
        this.$store.dispatch('openSnackbar', {
          mensaje: mensajeDeError(error, 'No se pudo cambiar la sede. Intente de nuevo.'),
          tipo: 'ERROR',
        });
      }
    },
    cerrarAvisoIp() {
      this.avisoIpCerrado = true;
      try { sessionStorage.setItem('avisoIpCerrado', '1'); } catch (e) { /* sin storage: reaparece */ }
    },
    cambiocontraseña() {
      this.$router.push("/cambiopasper");
    },
    salir() {
      sessionStorage.clear();
      this.$store.dispatch('setUser', { user: null });
      this.$router.push("/login");
    }
  },
  created: function () {
    this.bootstrapping = true;
    try { this.avisoIpCerrado = sessionStorage.getItem('avisoIpCerrado') === '1'; } catch (e) { /* ignorar */ }

    let userData = null;
    try {
      userData = JSON.parse(sessionStorage.getItem('session'));
    } catch (e) {
      userData = null;
    }

    if (userData) {
      this.$store.dispatch('setUser', { user: userData });
    } else if (this.$route.path !== '/login') {
      this.$router.push('/login');
    }

    this.bootstrapping = false;
  },
}
</script>

<style>
/* El enlace del aviso hereda el color del texto: el azul por defecto del
   navegador no se lee sobre el naranja. */
.aviso-ip .aviso-ip__enlace {
  color: inherit !important;
  font-weight: 700;
  text-decoration: underline;
}

.view-container {
  position: relative;
  min-height: calc(100vh - 64px - 58px);
}

.section-container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 3rem 0rem;
  min-height: 100vh;
}

.bg--primary {
  background-color: #002245 !important;
  color: white !important;
}

.bg--secondary {
  background-color: #EE680B !important;
  color: white !important;
}

.btn--primary--outline {
  border: 2px solid #002245 !important;
  color: #002245 !important;
}

.app-menu-tooltip {
  font-size: 13px !important;
  font-weight: 600;
  letter-spacing: 0.2px;
  padding: 8px 12px !important;
  max-width: 320px;
}

.v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
}

.app-drawer-header {
  border-bottom: 3px solid #EE680B;
  flex: 0 0 64px !important;
  height: 64px !important;
  max-height: 64px !important;
}

.app-drawer-header__logo {
  border-radius: 50%;
  flex: none;
}

.app-drawer-header__text {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
  margin-left: 10px;
}

.app-drawer-header__name {
  font-size: 0.82rem;
  font-weight: 700;
  color: #FFFFFF !important;
  letter-spacing: 0.3px;
}

.app-drawer-header__sub {
  font-size: 0.62rem;
  font-weight: 400;
  letter-spacing: 0.2px;
  color: rgba(255, 255, 255, 0.65);
}

.app-drawer-menu {
  padding-top: 10px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.app-drawer-menu__item {
  border-radius: 8px;
  margin: 2px 8px;
  min-height: 44px;
}

.app-drawer-menu__item .v-list-item__title {
  font-size: 0.72rem !important;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #33414F;
}

.app-drawer-menu__item .v-icon {
  color: #002245 !important;
}

.app-drawer-menu__item .v-list-item__icon {
  margin-right: 10px !important;
}

.app-drawer-menu__item:hover {
  background-color: #F4F6F8;
}

.app-drawer-menu__item.v-list-item--active {
  background-color: #EAF0F7;
  border-left: 3px solid #EE680B;
}

.app-drawer-menu__item.v-list-item--active .v-list-item__title {
  color: #002245 !important;
}

.app-drawer-menu__item.v-list-item--active .v-icon {
  color: #002245 !important;
}

.app-header {
  border-bottom: 3px solid #EE680B;
}

.app-header__user {
  display: flex;
  align-items: center;
  gap: 10px;
}

.app-header__user-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.25;
}

.app-header__user-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: 0.2px;
}

.app-header__user-sede {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 0.62rem;
  font-weight: 400;
  letter-spacing: 0.2px;
  color: rgba(255, 255, 255, 0.65);
  text-transform: uppercase;
}

/* La sede como control: mismo texto que la versión fija; se distingue por el
   contraste y la flecha, no por el tamaño de letra. */
.app-header .app-header__user-sede--elegible {
  background: none;
  border: 0;
  padding: 0;
  font-family: inherit;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
}
.app-header .app-header__user-sede--elegible:hover,
.app-header .app-header__user-sede--elegible:focus-visible {
  color: #FFFFFF;
  text-decoration: underline;
  outline: none;
}
.app-header .app-header__user-sede--elegible:disabled {
  cursor: progress;
}

.app-header__divider {
  border-color: rgba(255, 255, 255, 0.25) !important;
}

.app-footer {
  position: relative;
  flex-direction: column;
}

.app-footer__accent {
  height: 3px;
  width: 100%;
  background: linear-gradient(90deg, #EE680B 0%, #f7a35c 50%, #EE680B 100%);
}

.app-footer__content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 28px;
}

.app-footer__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #FFFFFF;
}

.app-footer__brand-logo {
  border-radius: 50%;
  flex: none;
}

.app-footer__brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}

.app-footer__brand-name {
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.app-footer__brand-sub {
  font-size: 0.68rem;
  font-weight: 400;
  letter-spacing: 0.2px;
  color: rgba(255, 255, 255, 0.7);
}

.app-footer__copy {
  font-size: 0.7rem;
  letter-spacing: 0.2px;
  color: rgba(255, 255, 255, 0.6);
  text-align: right;
}

@media (max-width: 599px) {
  .app-footer__content {
    flex-direction: column;
    text-align: center;
    padding: 14px 16px;
  }

  .app-footer__copy {
    text-align: center;
  }
}
</style>
